import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for M305 (訂單批號庫存表)
// ============================================================

export interface ReportRequest {
  warehouseFrom?: string;    // FM030_01 庫位起始
  warehouseTo?: string;      // FM030_01 庫位結束
  productFrom?: string;      // FM030_02 產品起始
  productTo?: string;        // FM030_02 產品結束
  batchFrom?: string;        // FM030_03 批號起始
  batchTo?: string;          // FM030_03 批號結束
  dateFrom?: string;         // FM030_13 日期起始 YYYY-MM-DD
  dateTo?: string;           // FM030_13 日期結束 YYYY-MM-DD
  reportType?: number;       // 1=庫位別 2=業績客戶別 3=板號
}

export interface ReportItem {
  fm030_01: string;          // 庫位
  fm030_02: string;          // 產品
  fm030_03: string;          // 批號
  fm030_12: string;          // 單位
  fm030_13: string | null;   // 入庫日
  fm030_16: number;          // 庫存量
  fm030_17: number;          // 庫存金額
  fm030_18: number;          // 平均單價
  fm030_21: string;          // 品名1
  fm030_22: string;          // 品名2
  fm030_23: string;          // 品名3
  fm030_24: number;          // 幅寬1
  fm030_25: number;          // 幅寬2
  fm030_26: number;          // 碼重
  fm030_27: number;          // 米平方重
  fm030_51: string;          // 色號
  fm030_57: string;          // 匹數
  warehouse_name: string;    // 庫位名稱
  color_name: string;        // 色號名稱
  contract_customer: string; // 合約客戶
}

export interface ReportResponse {
  items: ReportItem[];
  total: number;
}

// ============================================================
// API methods
// ============================================================

export const m305Api = {
  /** Query order batch inventory records with optional filters */
  async getReport(params: ReportRequest): Promise<ReportResponse> {
    const query: Record<string, string> = {};
    if (params.warehouseFrom?.trim()) query['warehouseFrom'] = params.warehouseFrom.trim();
    if (params.warehouseTo?.trim()) query['warehouseTo'] = params.warehouseTo.trim();
    if (params.productFrom?.trim()) query['productFrom'] = params.productFrom.trim();
    if (params.productTo?.trim()) query['productTo'] = params.productTo.trim();
    if (params.batchFrom?.trim()) query['batchFrom'] = params.batchFrom.trim();
    if (params.batchTo?.trim()) query['batchTo'] = params.batchTo.trim();
    if (params.dateFrom?.trim()) query['dateFrom'] = params.dateFrom.trim();
    if (params.dateTo?.trim()) query['dateTo'] = params.dateTo.trim();
    if (params.reportType) query['reportType'] = String(params.reportType);
    const res = await apiClient.get('/api/m305/report', { params: query });
    return res.data;
  },
};
